<template>
  <el-busena :busena="prasymasBusena" :color="busenaColor" />
</template>

<script>
export default {
  name: 'ElPrasymasBusena',
  props: {
    busena: String,
  },
  computed: {
    prasymasBusena() {
      return this.busena
    },
    busenaColor() {
      if (this.isBusenaIregistruotas) {
        return 'green'
      }
      if (this.isBusenaGrazintas) {
        return 'red'
      }
      if (this.isBusenaLaukiaApmokejimo || this.isBusenaLaukiaPatvirtinimo) {
        return '#0a5c8e'
      }
      return 'default'
    },
    isBusenaGrazintas() {
      return this.busena === 'grazintas' || this.busena === 'Grąžintas'
    },
    isBusenaIregistruotas() {
      return (
        this.busena === 'iregistruotas' ||
        this.busena === 'Įregistruotas' ||
        this.busena === 'Įvykdytas'
      )
    },
    isBusenaLaukiaPatvirtinimo() {
      return (
        this.busena === 'laukia_patvirtinimo' ||
        this.busena === 'Laukia patvirtinimo'
      )
    },
    isBusenaLaukiaApmokejimo() {
      return (
        this.busena === 'laukia_apmokejimo' ||
        this.busena === 'Laukia apmokėjimo'
      )
    },
  },
}
</script>
